import { useEffect, useState } from "react";
import API from "../services/api";
import { getAuthUser } from "../services/auth";

export default function Dashboard() {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(getAuthUser());

  const bgColors = {
    "Total Database": "bg-primary",
    Kementerian: "bg-success",
    "Pemerintah Daerah": "bg-warning",
    Lembaga: "bg-danger",
  };

  useEffect(() => {
    const fetchData = async () => {
      if (auth?.role === "tls" || auth?.role === "sales") {
        setLoading(false);
        return;
      }

      try {
        const res = await API.get("/dashboard/summary");
        setSummary(res.data.data);
      } catch (err) {
        console.error("Gagal mengambil data summary:", err);
      }

      setLoading(false);
    };

    fetchData();
  }, [auth]);

  if (auth === null) {
    return (
      <div className="container mt-4">
        <p>Memuat pengguna...</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Dashboard</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (auth.role !== "tls" && auth.role !== "sales") ? (
        <div className="row">
          {summary.map((item, index) => (
            <div className="col-md-3 mb-3" key={index}>
              <div
                className={`card text-center shadow-sm ${
                  bgColors[item.title] || "bg-secondary"
                } text-white`}
              >
                <div className="card-body">
                  <h5 className="card-title">{item.title}</h5>
                  <p className="card-text fs-3 fw-bold">{item.value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>Anda tidak memiliki akses ke dashboard ini.</p>
      )}
    </div>
  );
}
